import { colors } from '@lmc/common/constants'
import * as React from 'react'
import IconType from '../../general/Icon/iconTypes'
import ModuleCard from './ModuleCard'

type Props = {
  onClick?: () => void
}

export const EmarModuleCard = ({ onClick }: Props) => (
  <ModuleCard
    backgroundColor={colors.informationblue}
    icon={IconType.EmarHexagon}
    link="/emar-activation"
    linkText="Find out more"
    onClick={onClick}
    subtitle="Improve accountability and medication management."
    title="eMAR"
  />
)
